import { jsx as _jsx } from "react/jsx-runtime";
import { ProContent } from 'console/account/popup-for-pro';
import { AccountTariff } from 'console/billing/account-tariff/types';
import { accountTariffName } from 'console/billing/account-tariff/utils';
import { is_paid_tariff } from 'console/billing/billing-utils';
import branding from 'shared/app/model/branding';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { useCallback, useMemo } from 'react';
import { useNavigateTo } from 'shared/hooks/router';
import { AnimElements } from 'features/account.settings/model/animation-elements';
export const useHasPaidTariff = () => {
    const has_user_paid_tariff = useAppSelector(is_paid_tariff);
    const available_to_user = useMemo(() => branding.enable_zont_billing && branding.show_pro_requisition
        ? has_user_paid_tariff
        : true, [branding]);
    return available_to_user;
};
const selectAllowIconsPackage = (state) => state.account.allow_design_package;
const selectAnimPermissions = (state) => state.account.animation_permissions;
const selectTestPeriod = (state) => state.account.is_test_period;
export const useAllowDesignPackage = () => {
    return useAppSelector(selectAllowIconsPackage);
};
export const useTestPeriod = () => {
    return useAppSelector(selectTestPeriod) ?? false;
};
export const useDesignPackage = () => {
    const has_paid_tariff = useHasPaidTariff();
    const has_allow_design_package = useAllowDesignPackage();
    const has_test_period = useTestPeriod();
    const isSupportAccount = useSupportAccount();
    return ((has_paid_tariff || has_allow_design_package || has_test_period) &&
        !isSupportAccount);
};
export const useSupportAccount = () => {
    const requested_account = useAppSelector((state) => state.account);
    const real_account = useAppSelector((state) => state.account.real_account);
    if (real_account) {
        if (real_account.id == requested_account.id) {
            //Сотрудник тех.поддержки вошёл в свой аккаунт
            return false;
        }
    }
    return real_account?.is_support ?? false;
};
export const useAnimationPermissions = () => {
    const animation_permissions = useAppSelector(selectAnimPermissions);
    return {
        [AnimElements.flame]: animation_permissions?.flame ?? true,
        [AnimElements.heat_request]: animation_permissions?.heat_request ?? true,
        [AnimElements.bell_notification]: animation_permissions?.bell_notification ?? true,
        [AnimElements.car_autorun]: animation_permissions?.car_autorun ?? true,
        [AnimElements.car_lock]: animation_permissions?.car_lock ?? true,
        [AnimElements.car_smoke]: animation_permissions?.car_smoke ?? true,
        [AnimElements.car_siren]: animation_permissions?.car_siren ?? true,
        [AnimElements.sensor_alarm]: animation_permissions?.sensor_alarm ?? true,
        [AnimElements.circuit_alarm]: animation_permissions?.circuit_alarm ?? true,
    };
};
export const useAllowAnimatedFlame = () => {
    const allow_design_package = useDesignPackage();
    const animation_permissions = useAnimationPermissions();
    const animated_flame = useMemo(() => allow_design_package && animation_permissions.flame, [allow_design_package, animation_permissions.flame]);
    return animated_flame;
};
export const customIconsPackageTitle = 'Расширенный пакет значков';
export const useBuyDesignPackage = (close_popup) => {
    const tariffName = accountTariffName(AccountTariff.zont_pro);
    const openIconPackage = useNavigateTo('/billing/more-icons');
    const openChooser = useCallback(() => {
        openIconPackage();
        close_popup();
    }, [openIconPackage, close]);
    return (_jsx(ProContent, { text: `Больше возможностей в тарифе ${tariffName} или в отдельном наборе "${customIconsPackageTitle}"!`, maxWidth: 380, openChooser: openChooser }));
};
